(function () {
  // Prevent double-init when script is present on both theme.liquid and main-product.liquid
  if (window.__wishlistBtnInit) return;
  window.__wishlistBtnInit = true;

  /** @type {Set<string>|null} */
  let wishlistedIds = null;
  /** @type {Promise<Set<string>>|null} */
  let listFetchPromise = null;
  /** Guest when /list returned auth error (401/403) */
  let requiresLogin = false;

  const LOGIN_MSG =
    (window.wishlistStrings && window.wishlistStrings.loginToUse) ||
    'お気に入り機能はログイン後にご利用いただけます。';
  const UPDATE_FAILED_MSG =
    (window.wishlistStrings && window.wishlistStrings.updateFailed) ||
    'お気に入りの更新に失敗しました。もう一度お試しください。';

  // Event delegation — works for PDP, collection grids, and AJAX-replaced cards
  document.addEventListener('click', function (e) {
    const wishlistBtn = e.target.closest('.wishlist-btn[data-product-id]');
    if (wishlistBtn) {
      // Cards sit under product links / full-card hit areas — don't navigate away
      e.preventDefault();
      e.stopPropagation();
      handleToggle(wishlistBtn);
      return;
    }

    const shareBtn = e.target.closest('.share-btn--overlay');
    if (shareBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleShare(shareBtn);
    }
  });

  function buttonsFor(productId) {
    const id = String(productId);
    return document.querySelectorAll('.wishlist-btn[data-product-id="' + id + '"]');
  }

  function setActive(productId, isActive) {
    buttonsFor(productId).forEach((b) => {
      b.classList.toggle('active', isActive);
      b.setAttribute('aria-pressed', String(isActive));
    });
  }

  function setLoading(productId, isLoading) {
    buttonsFor(productId).forEach((b) => {
      b.classList.toggle('is-loading', isLoading);
    });
  }

  let toastTimer = null;
  let toastCloseTimer = null;

  function ensureToastStyles() {
    if (document.getElementById('wishlist-toast-style')) return;
    const style = document.createElement('style');
    style.id = 'wishlist-toast-style';
    style.textContent = [
      '#wishlist-toast{',
      'position:fixed!important;left:50%!important;top:max(20px,env(safe-area-inset-top,0px))!important;bottom:auto!important;',
      'z-index:2147483646!important;width:min(640px,calc(100vw - 32px))!important;max-width:min(640px,calc(100vw - 32px))!important;',
      'padding:18px 28px!important;border-radius:10px!important;',
      'background:#e8f4fc!important;color:#111!important;',
      'font-size:1.0625rem!important;line-height:1.55!important;letter-spacing:0.03em!important;font-weight:700!important;',
      'text-align:center!important;box-shadow:0 10px 32px rgba(0,0,0,0.14)!important;',
      'border:1px solid #b7d7ef!important;',
      'pointer-events:none!important;opacity:0;transform:translate(-50%,-12px);',
      'transition:opacity .22s ease,transform .22s ease;',
      'box-sizing:border-box!important;',
      '}',
      '#wishlist-toast.is-visible{opacity:1!important;transform:translate(-50%,0)!important;}',
      '#wishlist-toast.wishlist-toast--info{border-left:4px solid #2b7bb9!important;}',
      '#wishlist-toast.wishlist-toast--error{background:#fff4e8!important;border-color:#f0d2a8!important;border-left:4px solid #c98a2b!important;}',
      '@media (min-width:750px){#wishlist-toast{font-size:1.125rem!important;padding:20px 32px!important;}}',
    ].join('');
    document.head.appendChild(style);
  }

  function showToast(message, variant, onClose) {
    if (!message) return;
    ensureToastStyles();

    let host = document.getElementById('wishlist-toast');
    if (!host) {
      host = document.createElement('div');
      host.id = 'wishlist-toast';
      host.className = 'wishlist-toast';
      host.setAttribute('role', 'status');
      host.setAttribute('aria-live', 'polite');
      host.setAttribute('aria-atomic', 'true');
      document.body.appendChild(host);
    }

    host.textContent = message;
    host.classList.remove('wishlist-toast--info', 'wishlist-toast--error', 'is-visible');
    host.classList.add(
      variant === 'error' ? 'wishlist-toast--error' : 'wishlist-toast--info'
    );

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        host.classList.add('is-visible');
      });
    });

    if (toastTimer) clearTimeout(toastTimer);
    if (toastCloseTimer) clearTimeout(toastCloseTimer);
    toastTimer = setTimeout(function () {
      host.classList.remove('is-visible');
      if (typeof onClose === 'function') {
        // Wait for fade-out, then run follow-up (e.g. login redirect)
        toastCloseTimer = setTimeout(onClose, 250);
      }
    }, 3600);
  }

  function redirectToLogin() {
    window.location.href =
      '/account/login?return_url=' +
      encodeURIComponent(window.location.pathname + window.location.search);
  }

  function showLoginToast() {
    showToast(LOGIN_MSG, 'info', function () {
      if (requiresLogin) redirectToLogin();
    });
  }

  function isAuthErrorStatus(status) {
    return status === 401 || status === 403;
  }

  function ensureWishlistIds() {
    if (wishlistedIds) return Promise.resolve(wishlistedIds);
    if (!listFetchPromise) {
      listFetchPromise = fetch('/apps/wishlist/list')
        .then(async (res) => {
          // 401/403 = guest (RequireLoginGuard) — treat as empty, keep buttons inactive
          if (!res.ok) {
            if (isAuthErrorStatus(res.status)) requiresLogin = true;
            wishlistedIds = new Set();
            return wishlistedIds;
          }
          const data = await res.json();
          wishlistedIds = new Set((data.products || []).map((p) => String(p.id)));
          return wishlistedIds;
        })
        .catch(() => {
          wishlistedIds = new Set();
          return wishlistedIds;
        });
    }
    return listFetchPromise;
  }

  async function syncButtons() {
    const btns = document.querySelectorAll('.wishlist-btn[data-product-id]');
    if (!btns.length) return;

    const ids = await ensureWishlistIds();
    const seen = new Set();
    btns.forEach((btn) => {
      const id = String(btn.dataset.productId);
      if (seen.has(id)) return;
      seen.add(id);
      setActive(id, ids.has(id));
    });
  }

  async function handleToggle(btn) {
    const productId = String(btn.dataset.productId);
    const previousState = btn.classList.contains('active');

    // Resolve guest state before optimistic flip (list may already have told us)
    await ensureWishlistIds();
    if (requiresLogin) {
      setActive(productId, previousState);
      showLoginToast();
      return;
    }

    // Optimistic update — flip only this product's buttons
    setActive(productId, !previousState);
    setLoading(productId, true);
    try {
      const res = await fetch('/apps/wishlist/toggle', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: productId }),
      });

      if (isAuthErrorStatus(res.status)) {
        requiresLogin = true;
        setActive(productId, previousState);
        showLoginToast();
        return;
      }

      if (!res.ok) throw new Error('Error ' + res.status);

      const data = await res.json();
      setActive(productId, data.is_wishlisted);
      if (wishlistedIds) {
        if (data.is_wishlisted) wishlistedIds.add(productId);
        else wishlistedIds.delete(productId);
      }
    } catch {
      setActive(productId, previousState);
      showToast(UPDATE_FAILED_MSG, 'error');
    } finally {
      setLoading(productId, false);
    }
  }

  async function handleShare(btn) {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = url;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    btn.classList.add('copied');
    setTimeout(() => btn.classList.remove('copied'), 2000);
  }

  function nodeHasWishlistBtn(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches('.wishlist-btn[data-product-id]')) return true;
    return !!(node.querySelector && node.querySelector('.wishlist-btn[data-product-id]'));
  }

  // Re-sync when collection filters / infinite scroll inject new cards
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (nodeHasWishlistBtn(node)) {
          syncButtons();
          return;
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    syncButtons();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
      syncButtons();
    });
  }
})();
